import {
  type MarketButton, MarketModalPartial,
} from '@market/react';
import type { ReactElement, ReactNode } from 'react';
import { BankingModalBase } from './BankingModalBase';

/**
 * This modal components should handle 90% of all modals in Banking. This is
 * to promote consistent styling for modals across Banking.
 *
 * Another motivation for this modal component is that I am tired of applying
 * the same styling for header and description for every new modal. -cvu
 *
 * The content of the modal can be a string, which will be used in a paragraph
 * tag. This modal supports complex content by allowing it to also be a
 * ReactNode.
 *
 * Example:
 * const Content = <div>Look at me! I am going to be a ReactNode! Yippee!</div>;
 *
 * <BankingModalPartial {...props} content={Content}/>
 *
 * Buttons in Banking should be stacked most of the time. Buttons are passed as
 * arrays.
 */

type Content = string | ReactNode;

export interface BankingModalPartialProps {
  readonly active: boolean;
  readonly buttons?: ReactElement<typeof MarketButton>[];
  readonly content: Content;
  readonly title: string;
  readonly onModalClose: () => void;
}

export const BankingModalPartial = (props: BankingModalPartialProps) => (
  <BankingModalBase {...props} ModalWrapper={MarketModalPartial} />
);
